import { combineReducers } from 'redux';
import compose from './compose';
import * as fromCompose from './compose';
import execute from './execute';
import * as fromExecute from './execute';

export default combineReducers({
  compose,
  execute,
});

export const getFirstEvent = (state) => fromCompose.getFirstEvent(state.compose);

export const getFirstEventFilter = (state) => fromCompose.getFirstEventFilter(state.compose);

export const getReturnEvent = (state) => fromCompose.getReturnEvent(state.compose);

export const getReturnEventFilter = (state) => fromCompose.getReturnEventFilter(state.compose);

export const getUseLatestProfile = (state) => fromCompose.getUseLatestProfile(state.compose);

export const getDimensionType = (state) => fromCompose.getDimensionType(state.compose);

export const isCustomSequenceEnabled = (state) =>
  fromCompose.isCustomSequenceEnabled(state.compose);

export const getCustomSequenceType = (state) => fromCompose.getCustomSequenceType(state.compose);

export const getCustomSequence = (state) => fromCompose.getCustomSequence(state.compose);

export const getCustomSequenceDimensions = (state) =>
  fromCompose.getCustomSequenceDimensions(state.compose);

export const getIdUsingTemplate = (state) => fromCompose.getIdUsingTemplate(state.compose);

export const getFilterFor = (state, eventIndex) =>
  fromCompose.getFilterFor(state.compose, eventIndex);

export const getRetentionComplexSQL = (state) => fromCompose.getRetentionComplexSQL(state.compose);

export const getError = (state) => fromCompose.getError(state.compose);

export const getExecutionResult = (state) => fromExecute.getResult(state.execute);

export const getExecutedQuery = (state) => fromExecute.getQuery(state.execute);

export const getOptions = (state) => fromExecute.getOptions(state.execute);

export const getExecuteTime = (state) => fromExecute.getExecuteTime(state.execute);

export const isExecuting = (state) => fromExecute.isExecuting(state.execute);

export const getExecuteId = (state) => fromExecute.getExecuteId(state.execute);
